<template>
    <v-card v-if="quote">
        <v-card-title primary-title>
          <div style="width:100%; text-align: right">
            <small>{{quote.description}}</small>
            <h3 class="display-2 mb-0">${{quote.last}}</h3>
            <h4 :class="subtitleClass">{{quote.change_percentage}}%</h4>
          </div>
        </v-card-title>
    </v-card>
</template>

<script>
export default {
  props: {
    quote: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {
    subtitleClass() {
      return {
        'red--text': this.quote.change_percentage < 0,
        'green--text': this.quote.change_percentage >= 0,
        headline: true,
      };
    },
  },
  watch: {

  },

};
</script>
